// Texts for the world 'toothbrush': the name on the map, the level titles and the comic words in the scene (scene.ts), per language.
// The ids must be the level ids in levels.ts (npm run validate checks this); other languages must have the same ids as da (tsc).
import { defineWorldStrings } from '../../core/i18n';

export const strings = defineWorldStrings({
  da: {
    name: 'Tandbørste',
    levels: {
      'splash': { title: 'Plask' },
      'bubbles': { title: 'Bobler' },
      'sponge-bridge': { title: 'Svampebro' },
      'sponge-or-soap': { title: 'Svamp eller sæbe' },
      'boat': { title: 'Båden' },
      'two-bubbles': { title: 'To bobler' },
      'tap': { title: 'Hanen' },
      'two-holes': { title: 'To huller' },
      'out-of-the-tub': { title: 'Op af karret' },
      'who-carries': { title: 'Hvem bærer?' },
      'which-way': { title: 'Hvilken vej' },
      'bridge-and-bubbles': { title: 'Bro og bobler' },
      'lift-the-boat': { title: 'Løft båden' },
      'hop-in-the-bath': { title: 'Hop i badet' },
      'master': { title: 'Mester' },
    },
    scene: {
      'scrub': 'SKRUB!',
    },
  },
  en: {
    name: 'Toothbrush',
    levels: {
      'splash': { title: 'Splash' },
      'bubbles': { title: 'Bubbles' },
      'sponge-bridge': { title: 'Sponge bridge' },
      'sponge-or-soap': { title: 'Sponge or soap' },
      'boat': { title: 'The boat' },
      'two-bubbles': { title: 'Two bubbles' },
      'tap': { title: 'The tap' },
      'two-holes': { title: 'Two holes' },
      'out-of-the-tub': { title: 'Out of the bath' },
      'who-carries': { title: 'Who carries it?' },
      'which-way': { title: 'Which way?' },
      'bridge-and-bubbles': { title: 'Bridge and bubbles' },
      'lift-the-boat': { title: 'Lift the boat' },
      'hop-in-the-bath': { title: 'Hop in the bath' },
      'master': { title: 'Master' },
    },
    scene: {
      'scrub': 'SCRUB!',
    },
  },
});
